import { ArrowRight, Users } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'
import { FaLinkedinIn } from "react-icons/fa";


const BussinessProgram = () => {
  return (
     <>
    <section className="container mx-auto px-4 sm:px-6 py-8">
      <div className="flex flex-col lg:flex-row items-center gap-11 lg:gap-16">

        {/* Left - Image (hidden on mobile) */}
        <div className="flex-1 hidden lg:flex justify-center">
          <img
            src="/newbussiness.png"
            alt="Business Consultation"
            className="w-full max-w-md object-cover rounded-2xl max-h-[230px]"
          />
        </div>

        {/* Right - Content */}
        <div className="flex-1 text-center lg:text-left">
          

          <h1 className="text-[20px] md:text-5xl lg:text-4xl font-bold text-gray-800 mb-3 leading-tight">
          TACTOS  
            <span className="text-[#fd3e3d]"> Business Consultation</span>
          </h1>

          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#fd3e3d]/10 text-[#fd3e3d] text-sm font-medium mb-4">
            <Users className="w-4 h-4" />
            
            <span>Build Smarter. Scale Faster. Succeed Strategically.</span>
          </div>

          <p className="text-black/70 text-sm md:text-md mb-5 max-w-xl mx-auto lg:mx-0">
            End-to-end business guidance from diagnosis to strategy to execution.
            TACTOS acts as your fractional CXO team, driving decisions and
            operational clarity. We help companies fix bottlenecks, accelerate
            growth, and become system-driven.
          </p>

          {/* <h2 className="text-[20px] font-bold text-gray-800 mb-3">
            What is TACTOS Business{' '}
            <span className="text-[#fd3e3d]">Consultation?</span>
          </h2>

          <p className="text-black/70 text-xs mb-6 max-w-xl mx-auto lg:mx-0">
            TACTOS provides end-to-end business consulting for startups, SMEs,
            institutions, and emerging founders. From idea validation to
            strategy execution, we act as your strategic partner.
          </p> */}

          {/* CTA */}
          <div className="flex justify-center lg:justify-start">
            <Link
              to="/instructions/bussiness"
              className="group inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635] text-white font-semibold py-3 px-8 rounded-xl transition-all duration-300 shadow-lg shadow-[#fd3e3d]/25 hover:shadow-[#fd3e3d]/40"
            >
              Apply Now
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>

      </div>
    </section>
   
<section className="container mx-auto px-4 sm:px-6 py-10">
  {/* OUTER RUNNING BORDER */}
  <div className="relative p-[2px] rounded-2xl running-border-linkedin">
    
    {/* INNER CARD */}
    <div
      className="relative rounded-2xl overflow-hidden"
      style={{
        backgroundImage:
          "url('/dividerimg.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 px-6 md:px-10 py-8">
        
        {/* Left Text */}
        <h2 className="text-white text-lg md:text-2xl font-bold text-center md:text-left max-w-xl">
          Let’s Talk Strategy, Growth & Execution
          <span className="block font-bold">
            Connect with TACTOS on{" "}
            <span className="text-[#0A66C2]">LinkedIn</span>
          </span>
        </h2>

        {/* BUTTON RUNNING BORDER */}
        <a
          href="https://www.linkedin.com/company/tactos-strategic-solutions-llp/"
          target="_blank"
          rel="noopener noreferrer"
          className="relative p-[2px] rounded-xl running-border-btn-linkedin"
        >
          <span
            className="
              relative z-10
              inline-flex items-center gap-3
              bg-[#0A66C2] hover:bg-[#004182]
              text-white font-semibold
              px-6 py-3 rounded-xl
              shadow-lg transition
            "
          >
            <FaLinkedinIn className="text-xl" />
            Connect on LinkedIn
          </span>
        </a>
      </div>
    </div>
  </div>
</section>



    </>
  )
}

export default BussinessProgram
